export class PaginationReq {
    current: number;
    pageSize: number;
    total: number;
    constructor(
        current: number,
        pageSize: number,
        total: number
    ){
        this.current = current
        this.pageSize = pageSize
        this.total = total
    }
}